module.exports = "/_next/static/images/web-i-os-android-7ac948357cb95bb814332e20e10bc9fa.png";